import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=b82de31e&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=b82de31e&prod&lang=scss&scoped=true"
import style1 from "./OrderHistory.vue?vue&type=style&index=1&id=b82de31e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82de31e",
  null
  
)

export default component.exports